import { useCallback, useEffect, useRef, useState } from "react";
import { isPaletteShortcut } from "../CommandPalette/CommandPalette";

export interface CommandPaletteControl {
  open: boolean;
  /** What the palette's search starts with. */
  seed: string;
  openPalette: (initialQuery?: string) => void;
  close: () => void;
}

export function useCommandPalette(): CommandPaletteControl {
  const [open, setOpen] = useState(false);
  const [seed, setSeed] = useState("");
  const openPalette = useCallback((initialQuery = "") => {
    setSeed(initialQuery);
    setOpen(true);
  }, []);
  const close = useCallback(() => setOpen(false), []);
  return { open, seed, openPalette, close };
}

/** Runs `onShortcut` on ⌘F / ⌘K (Ctrl elsewhere) anywhere in the page while the palette is closed. */
export function usePaletteShortcut(paletteOpen: boolean, onShortcut: () => void): void {
  const onShortcutRef = useRef(onShortcut);
  onShortcutRef.current = onShortcut;

  useEffect(() => {
    if (paletteOpen) return;
    function onKey(e: KeyboardEvent): void {
      if (!isPaletteShortcut(e)) return;
      e.preventDefault();
      onShortcutRef.current();
    }
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [paletteOpen]);
}
